import { render, staticRenderFns } from "./AddFundraising.vue?vue&type=template&id=27f9b162&scoped=true&lang=html&"
import script from "./AddFundraising.vue?vue&type=script&lang=js&"
export * from "./AddFundraising.vue?vue&type=script&lang=js&"
import style0 from "./AddFundraising.vue?vue&type=style&index=0&id=27f9b162&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f9b162",
  null
  
)

export default component.exports